module.exports = __webpack_public_path__ + "img/av237.733fb3d0.png";